
import { defineComponent } from "vue";

import StaticArticle from "../components/static-article.vue";
import { getStaticPage } from "../data/pages";
import common from "../styles/common.module.less";

export default defineComponent({
  name: "XiyouFees",
  setup() {
    const page = getStaticPage("fees");
    return () => (
      <div class={common.shell}>
        {page ? <StaticArticle page={page} /> : null}
      </div>
    );
  },
});
